<rt-assistant-list-card>
  <div class="rows">
    <div class="title-row">
      <rt-checkbox class="checkbox" [checked]="!!data().completed" [hasMargin]="false" />
      <span class="title">{{ data().title }}</span>
    </div>
    <div class="bottom-row">
      @if (data().dueDate; as dueDate) {
        <span class="due">{{ dueDate | amDateFormat: 'D MMM YYYY, HH:mm' }}</span>
      }
      @if (avatarUsers().length > 0) {
        <rt-admins-avatars
          class="assignees"
          variant="ltr"
          avatarSize="small-x"
          [admins]="avatarUsers()"
          [stacked]="true"
          [limit]="3"
        />
      }
    </div>
  </div>
</rt-assistant-list-card>
